import React from 'react';
import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import { ModalProps, ModalTypes, useModalContext } from 'application/providers/ModalProvider';
import { TEXTS } from 'application/pages/PointsPage/renderer/texts';
import HelpModalContent from './HelpModalContent';
import { DATA_TEST_IDS } from './consts';
import styles from './index.module.scss';

const CutMusicHelpModal: React.FC<ModalProps[ModalTypes.MUSIC_CUT_HELP_MODAL]> = ({ close, variant }) => {
  const { isModalOpen } = useModalContext();

  return (
    <ModalScreen
      elementId={DATA_TEST_IDS.MODAL}
      contentElementId={DATA_TEST_IDS.BODY}
      title={<span data-testid={DATA_TEST_IDS.TITLE}>{TEXTS.CUT_MUSIC_HELP[variant].title}</span>}
      onClose={() => close()}
      disableScroll={isModalOpen}
      containerClassName={styles.container}
      titleClassName={styles.title}
      actionButtons={[
        <Button
          key={DATA_TEST_IDS.CONFIRM}
          elementId={DATA_TEST_IDS.CONFIRM}
          type={ButtonType.PRIMARY}
          onClick={() => close()}>
          {TEXTS.CUT_MUSIC_HELP_MODAL_BUTTON}
        </Button>,
      ]}>
      <HelpModalContent
        key={variant}
        variant={variant}
      />
    </ModalScreen>
  );
};

export default CutMusicHelpModal;
